<template>
  <v-layout column>
    <vbt-content-box
      :loading="isLoading"
      :loading-error="loadingError"
      :no-content="noContent"
      :go-back-btn="goBack"
      title="Information"
    >
      <template #toolbar>
        <v-btn
          small
          class="ml-4"
          color="success"
          @click="openEditorDialog()"
        >
          Create tenant
        </v-btn>
      </template>
      <vbt-table
        :items="tenants"
        :headers="headers"
        show-actions
        show-edit-action
        @click:edit="openEditorDialog"
      >
        <template #append-actions="{ item }">
          <v-layout align-center>
            <v-tooltip left>
              <template #activator="{ on }">
                <v-btn
                  :to="{ name: 'tenantHistory', params: { tenant: item.name } }"
                  color="info"
                  icon
                  v-on="on"
                >
                  <v-icon>
                    book
                  </v-icon>
                </v-btn>
              </template>
              History
            </v-tooltip>
          </v-layout>
        </template>
      </vbt-table>

      <vbt-pagination
        v-model="pageNum"
        :items-count="pagedItemsCount"
      />
    </vbt-content-box>

    <ums-tenant-editor
      v-model="editorDialog"
      :creator="isEditorCreateMode"
      :item="editableTenant"
      @success="$_fetchData"
    />
  </v-layout>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import { useDataLoading, usePagination, useEditorWithDialog } from '@mixins/factories';

import { namespace as TenantsNamespace, ActionTypes as TenantsActionTypes } from '../store.types';

import UmsTenantEditor from '../_components/UmsTenantEditor.vue';

const dataLoadingOptions = {
  getterName: TenantsActionTypes.GET_TENANTS,
  contentName: 'tenants',
  searchable: false,
};
const paginationOptions = { contentName: 'tenants' };

const headers = Object.freeze([
  { text: 'Name', value: 'name' },
  { text: 'Short Name', value: 'short_name' },
  { text: 'Tenant ID', value: 'tenant_id' },
  { text: 'Azure Tenant Name', value: 'azure_tenant_name' },
  { text: 'Azure Tenant ID', value: 'azure_tenant_id' },
]);

export default {
  name: 'UmsTenants',
  components: {
    UmsTenantEditor,
  },
  mixins: [
    usePagination(paginationOptions),
    useDataLoading(dataLoadingOptions),
    useEditorWithDialog({ editableItemName: 'editableTenant' }),
  ],
  data: () => ({ headers }),
  computed: {
    ...mapState(TenantsNamespace, ['tenants']),
  },
  methods: {
    ...mapActions(TenantsNamespace, [TenantsActionTypes.GET_TENANTS]),
  },
};
</script>
